/* eslint camelcase: 0 */
const generateCardEventStreamProps = (props) => {
  const {
    content_id,
    content_type,
    index,
    recommendation_set_ids,
    search_id,
    parentSlug,
    referrer,
  } = props;
  const streamEventProps = {
    actionName: "Navigate",
    objectType: "Content",
    streamProperties: {
      content_id,
      content_type,
      layout_index: index,
      parent_row: {
        row_slug: parentSlug,
      },
      search_id,
      recommendation_set_ids,
      referrer,
    },
  };

  return streamEventProps;
};

export default generateCardEventStreamProps;
